import React from 'react';
import video from  "../src/component/video.mp4";

function New() {
    return (
<div>
    <video autoPlay loop muted
    style={{
        position:"absolute",
        width:"auto",
        left:"50%",
        top:"50%",
        height:"auto",
        objectFit:"cover",
        transform:"translate(-50%, -50%)",
        zIndex:"-1",
        minWidth: "100%",
   minHeight: "100%",
   maxHeight:" 100%",
   width: "100%",
 
    }}>
        <source src={video} />
    </video>
</div>
    );
}

export default New;
